import {
  Box,
  Button,
  Stack,
  Tab,
  Tabs,
  Typography,
  Autocomplete,
  Slider,
} from "@mui/material";
import { useState } from "react";
import { styled } from "@mui/material/styles";
import DragAndDropFileUpload from "../DragAndDropFileUpload";
import PrimaryTextField from "../../component/PrimaryTextField";

const TabPanel = ({ children, value, index }) => {
  return value === index ? <Box sx={{ pt: 2 }}>{children}</Box> : null;
};

const StyledTabs = styled(Tabs)({
  borderBottom: "2px solid #E0E0E0",
  "& .MuiTab-root": {
    textTransform: "none",
    fontWeight: 600,
    color: "#555",
    "&.Mui-selected": {
      color: "#4CAF50",
    },
  },
  "& .MuiTabs-indicator": {
    backgroundColor: "#4CAF50",
  },
});

export const InsertImageTabs = ({
  activeLogo,
  uploadedLogos,
  setUploadedLogos,
  handleUploadPreviewSVG,
  searchLogo,
  logoOptions,
  loading,
  preview,
  setPreview,
  addImageToCanvas,
}) => {
  const [tabIndex, setTabIndex] = useState(0);

  // For internal uploader
  const [uploadLoading, setUploadLoading] = useState(false);
  const [localPreview, setLocalPreview] = useState("");
  const [uFiles, setUFiles] = useState(null);

  const s3Path = process.env.REACT_APP_ASSETS_URL + "poi/svg/";

  const handleChange = (_, newValue) => {
    setTabIndex(newValue);
  };

  const handleFileUpload = (files) => {
    setUFiles(files);
    const reader = new FileReader();
    reader.onload = (e) => {
      if (e.target?.result) {
        setLocalPreview(e.target.result);
      }
    };
    reader.readAsDataURL(files[0]);
  };

  const handleUpload = async () => {
    setUploadLoading(true);
    try {
      if (!uFiles || uFiles.length === 0 || !localPreview) {
        throw new Error("No image selected");
      }
      addImageToCanvas(localPreview);
      setLocalPreview("");
      setUFiles(null);
    } catch (err) {
      console.error("Error uploading image:", err);
    } finally {
      setUploadLoading(false);
    }
  };

  return (
    <Box sx={{ bgcolor: "#fff", p: 2, borderRadius: 2, width: "100%" }}>
      <StyledTabs value={tabIndex} onChange={handleChange}>
        <Tab label="Select" />
        <Tab label="Upload " />
      </StyledTabs>

      {/* === Select TAB === */}
      <TabPanel value={tabIndex} index={0}>
        <Stack spacing={2}>
          <Autocomplete
            disablePortal
            options={logoOptions}
            loading={loading}
            onChange={(_, value) =>
              value ? setPreview(`${s3Path}${value.retailerId}.svg`) : {}
            }
            renderInput={(params) => (
              <PrimaryTextField
                placeholder="Search Logo"
                onChange={searchLogo}
                {...params}
              />
            )}
          />

          <Box
            sx={{
              background: "#F5F5F5",
              height: 110,
              borderRadius: 2,
              border: "1px solid #ccc",
              overflow: "hidden",
            }}
          >
            <Box
              sx={{
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {preview ? (
                <img
                  src={preview}
                  style={{
                    height: "100%",
                    width: "100%",
                    objectFit: "contain",
                  }}
                  alt="Preview"
                />
              ) : (
                <Typography sx={{ color: "#999", fontSize: 18 }}>
                  No Image Preview
                </Typography>
              )}
            </Box>
          </Box>
          {/* <Button
            variant="contained"
            onClick={handleUploadPreviewSVG}
            sx={{
              bgcolor: "#4CAF50",
              color: "white",
              borderRadius: "8px",
              textTransform: "none",
              fontWeight: "500",
              ":hover": { bgcolor: "#43a047" },
              width: "fit-content",
            }}
          >
            Upload
          </Button> */}

          <Button
            variant="contained"
            onClick={() =>
              setUploadedLogos([
                ...uploadedLogos,
                { src: `${preview}`, size: 200 },
              ])
            }
            sx={{
              bgcolor: "#4CAF50",
              color: "white",
              borderRadius: "8px",
              textTransform: "none",
              fontWeight: "500",
              ":hover": { bgcolor: "#43a047" },
              width: "fit-content",
            }}
          >
            Upload
          </Button>
        </Stack>
      </TabPanel>

      {/* === UPLOAD TAB === */}
      <TabPanel value={tabIndex} index={1}>
        <Stack spacing={2} marginBottom={5}>
          <Box
            sx={{
              height: 140,
              backgroundColor: "#F5F5F5",
              borderRadius: 2,
              border: "1px dashed #ccc",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {localPreview ? (
              <img
                src={localPreview}
                style={{ height: "100%", objectFit: "contain" }}
                alt="Uploaded Preview"
              />
            ) : (
              <DragAndDropFileUpload
                onFileUpload={handleFileUpload}
                // acceptedFormats=".jpg,.jpeg,.png"
              />
            )}
          </Box>

          <Stack direction="row" justifyContent="center" spacing={2}>
            <Button
              disabled={uploadLoading || !localPreview}
              // onClick={handleUpload}
              onClick={() => {
                setUploadedLogos([
                  ...uploadedLogos,
                  { src: `${localPreview}`, size: 200 },
                ]);
                setLocalPreview("");
                setUFiles(null);
              }}
              variant="contained"
              sx={{
                bgcolor: "#4CAF50",
                color: "white",
                fontWeight: "bold",
                textTransform: "none",
                ":hover": { bgcolor: "#43a047" },
              }}
            >
              Upload
            </Button>
            <Button
              onClick={() => {
                setLocalPreview("");
                setUFiles(null);
              }}
              variant="outlined"
              sx={{
                fontWeight: "bold",
                textTransform: "none",
                color: "#f44336",
                borderColor: "#f44336",
                ":hover": {
                  bgcolor: "#ffecec",
                  borderColor: "#f44336",
                },
              }}
            >
              Cancel
            </Button>
          </Stack>
        </Stack>
      </TabPanel>
      <Stack width={"100%"} alignItems="center" spacing={2}>
        {activeLogo
          ? (() => {
              const activeItem = uploadedLogos.find(
                (d) => d.src === activeLogo
              );
              const sliderValue = Math.round((activeItem?.size || 200) / 10);
              return (
                <>
                  <Typography sx={{ fontSize: 15 }}>Scale:</Typography>
                  <Slider
                    min={1}
                    max={100}
                    step={1}
                    value={sliderValue}
                    valueLabelDisplay="auto"
                    valueLabelFormat={(value) => `${value}%`}
                    onChange={(_e, value) => {
                      const newSize = value * 10;
                      // update size for the active logo in the array

                      setUploadedLogos((prev) =>
                        prev.map((item) =>
                          item.src === activeLogo
                            ? { ...item, size: newSize }
                            : item
                        )
                      );
                    }}
                  />
                </>
              );
            })()
          : ""}
      </Stack>
    </Box>
  );
};
